import _ from 'lodash';
import config from '../config/config';
import Interface from '../handlers/Interface';

// Each endpoint has a property "localisationBy{param|query|body}" that gives information where to inject the currently selected country/language (primarily in terms of national databases)
// if it is query, the string value gives the key name. if it is body, the string contained gives the required property name

class API {
    interface;
    bearerToken;
    countryDb;

    constructor(){
        if( !!localStorage.getItem('atkn') ){
            this.bearerToken = localStorage.getItem('atkn');
        }

        if( !!localStorage.getItem('lclcntyid') ){
            this.countryDb = parseInt(localStorage.getItem('lclcntyid'));
        } else {
            this.countryDb = 7;
        }

        this.interface = new Interface(); //Optionally, a token can be provided to the constructor
    }

    _verbs = {}

    execute(verb, params, body){
        var prms = [];

        if(!!this._verbs[verb].localisationByParam && !!this.countryDb){
            prms.push(this.countryDb);
        }


        if(_.isString(params)) prms.push(params);
        else if(_.isArray(params)) prms = prms.concat(params);

        // -- Below option is not yet in use
        // if(!!this._verbs[verb].localisationByQuery && !!this.countryDb){
        //     prms.push(this.countryDb);
        // }

        if(!!this._verbs[verb].localisationByBody && !!this.countryDb){
            if(!body) body = {}
            body[this._verbs[verb].localisationByBody] = this.countryDb;
        }

        return this.interface.execute(this._verbs[verb].method, _.extend(this._verbs[verb].endpoint, { params: prms}), body, this._verbs[verb].token );
    }
}

export class AuthAPI extends API{
    constructor(){
        super();
    }

    _verbs = {
        login: { method: 'post', endpoint: { url: '/login/login' } },
        register: { method: 'post', endpoint: { url: '/login/register' } },
        verify: { method: 'post', endpoint: { url: '/login/verifyuser?username=%s&token=%s' } },
        reset: { method: 'post', endpoint: { url: '/login/reset' } },
        updateUser: { method: 'post', endpoint: { url: '/user/updateuser' }, token: this.bearerToken },
        updatePassword: { method: 'post', endpoint: { url: '/user/updatepassword' }, token: this.bearerToken }
    }
}

export class DrugAPI extends API{
    constructor(){
        super();
    }

    _verbs = {
        //getDrugs: { method: 'get', endpoint: { url: '/drug/GetDrugs'}, token: this.bearerToken },
        //getPharmaceuticalForms: { method: 'get', endpoint: { url: '/drug/GetPharmaceuticalForm' }, token: this.bearerToken },
        //GetDrugById: { method: 'get', endpoint: { url: '/drug/GetDrugById/%s'}, token: this.bearerToken },
        //GetProducts: { method: 'get', endpoint: { url: '/drug/GetProducts'}, token: this.bearerToken },
        getAdministrationMethods: { method: 'get', endpoint: { url: '/drug/GetAdministrationMethods/%s'}, token: this.bearerToken, localisationByParam: true },
        GetCountries: { method: 'get', endpoint: { url: '/drug/GetCountries/%s'}, token: this.bearerToken, localisationByParam: true },
        GetAllCountries: { method: 'get', endpoint: { url: '/drug/GetCountries'}, token: this.bearerToken },
        QueryProducts: { method: 'post', endpoint: { url: '/drug/GetProducts' }, token: this.bearerToken, localisationByBody: 'CountryDbId' },
        GetProductById: { method: 'get', endpoint: { url: '/drug/GetProductById/%s' }, token: this.bearerToken }

    }
}

export class PublicAPI extends API{
    constructor(){
        super();
    }

    _verbs = {
        getLocales: { method: 'get', endpoint: { url: '/public/getLocales' } }
    }
}

export default API;
